import { createElement } from 'react';
import PropTypes from 'prop-types';

const ComputedField = (
  { component, computation, hideInEdit = false, ...other },
  { editing, formValues, localeMessage },
) =>
  !(editing && hideInEdit)
    ? createElement(
        component || 'div',
        component ? { input: { value: computation(formValues) }, editing: false, localeMessage, ...other } : {},
        component ? null : computation(formValues),
      )
    : null;

ComputedField.propTypes = {
  hideInEdit: PropTypes.bool,
  computation: PropTypes.func,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.element]),
};

ComputedField.contextTypes = {
  editing: PropTypes.bool,
  formValues: PropTypes.object,
  localeMessage: PropTypes.func,
};

export default ComputedField;
